import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/sections/HeroSection';
import { WhatIsMeeloSection } from '../components/sections/WhatIsMeeloSection';
import { DashboardSection } from '../components/sections/DashboardSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { FindSolutionCTASection } from '../components/sections/FindSolutionCTASection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { SocialProofSection } from '../components/sections/SocialProofSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { Footer } from '../components/Footer';
// Thin gradient divider between sections
function SectionDivider({
  variant = 'line'
}: {
  variant?: 'line' | 'glow';
}) {
  if (variant === 'glow') {
    return <div aria-hidden="true" style={{
      height: 1,
      background: 'transparent',
      position: 'relative',
      overflow: 'visible'
    }} data-id="element-368" data-mp="llmf4btbd5c9">
        <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: 40,
        background: 'radial-gradient(ellipse at center, rgba(124,77,255,0.10) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} data-id="element-369" data-mp="33kig0mkdl22b" />
      </div>;
  }
  return <div aria-hidden="true" style={{
    height: 1,
    margin: '0 auto',
    width: '80%',
    background: 'linear-gradient(90deg, transparent 0%, rgba(124,77,255,0.15) 30%, rgba(124,77,255,0.25) 50%, rgba(124,77,255,0.15) 70%, transparent 100%)'
  }} data-id="element-370" data-mp="3n7zytczb8h5m" />;
}
export function LandingPage() {
  // Section scroll-reveal: observe all <section> elements
  useEffect(() => {
    // Handle scroll-to from MissionPage
    const scrollTarget = sessionStorage.getItem('scrollTo');
    if (scrollTarget) {
      sessionStorage.removeItem('scrollTo');
      setTimeout(() => {
        document.getElementById(scrollTarget)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 350);
    }
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('main > .section-wrap');
    if (prefersReduced) {
      sections.forEach(el => el.classList.add('section-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.06
    });
    sections.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans text-gray-900" data-id="element-371" data-mp="5ouk1oxk9w12">
      <Navbar data-id="element-372" data-mp="pe242f5dpqhd" />
      <main data-id="element-373" data-mp="pdikku02yu18">
        {/* Hero — no reveal wrapper, always visible */}
        <HeroSection data-id="element-374" data-mp="uaskx4p0cq3u" />

        <div className="section-wrap" data-id="element-375" data-mp="ub2batdysza2">
          <DashboardSection data-id="element-376" data-mp="fetdzxdmww0a" />
        </div>

        <div className="section-wrap" data-id="element-377" data-mp="fdrquujcgj27">
          <SolutionSection data-id="element-378" data-mp="fgxd820l96u8" />
        </div>

        <SectionDivider variant="line" data-id="element-379" data-mp="kcmimlzahhyg" />
        <div className="section-wrap" data-id="element-380" data-mp="kfqve7qtlm0q">
          <FindSolutionCTASection data-id="element-381" data-mp="6lpqsxd6t4sg" />
        </div>

        <SectionDivider variant="line" data-id="element-382" data-mp="6ky98qgfd7l6" />
        <div className="section-wrap" data-id="element-383" data-mp="bcpr8clim4zp">
          <ResultsSection data-id="element-384" data-mp="bdr9p24v1trg" />
        </div>

        <SectionDivider variant="glow" data-id="element-385" data-mp="3sthc5au75pzv" />
        <div className="section-wrap" data-id="element-386" data-mp="3suiorjqv2kjp">
          <SocialProofSection data-id="element-387" data-mp="3srcza3eblgng" />
        </div>

        <SectionDivider variant="line" data-id="element-388" data-mp="1md72lhm4du3" />
        <div className="section-wrap" data-id="element-389" data-mp="1nfxksb0we9h">
          <FinalCTASection data-id="element-390" data-mp="3jt1c6bcnx0zr" />
        </div>
      </main>
      <Footer data-id="element-391" data-mp="3jtazfr6bou1r" />
    </div>;
}